"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const PaymentIcons = ({ saatvaDomain = 'https://www.saatva.com' }) => {
    const [isSafari, setIsSafari] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (typeof window.ApplePaySession !== 'undefined' &&
            window.ApplePaySession.canMakePayments()) {
            setIsSafari(true);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: styles_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-visa.svg`, alt: "Visa" }), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-mastercard.svg`, alt: "Mastercard" }), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-discover.svg`, alt: "Discover" }), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-amex.svg`, alt: "American Express" }), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-paypal.svg`, alt: "Paypal" }), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-googlepay.svg`, alt: "Google Pay" }), isSafari && ((0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-applepay.svg`, alt: "Apple Pay" })), (0, jsx_runtime_1.jsx)("img", { src: `${saatvaDomain}/static/assets/icons/u-payment-affirm.svg`, alt: "Affirm" })] }));
};
PaymentIcons.propTypes = {
    /** Saatva domain */
    saatvaDomain: prop_types_1.default.string
};
exports.default = PaymentIcons;
//# sourceMappingURL=index.js.map